import React, { useContext, memo } from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { IconButton, Typography, List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';
import { Theme } from '../contexts/themeContext.js';
import { GlobalTheme } from "../../layouts/theme";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        overflowY: 'auto'
    },
    mobileView: {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            display: 'inline-flex'
        }
    },
    text: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '15px',
            fontSize: 'initial'
        }
    },
    pop: {
        backgroundColor: 'inherit',
        width: 'max-content',
        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
    }
}));

const Settings = (props) => {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const currentTheme = GlobalTheme[theme];
    const settingMenus = props.appSettingMenus ? props.appSettingMenus : [];
    const trainingMode = props.trainingMode;

    const isAuthorized = (name) => {
        if (settingMenus !== undefined && settingMenus.length > 0) {
            const index = settingMenus.findIndex(item => item === name);
            return (index === -1) ? false : true;
        }
        
         return false;
    };

    if (settingMenus.length <= 0)
        return (<></>);

   
        return (
            <div>
                <IconButton color="inherit" id="PopoverLegacy" disabled={trainingMode}>
                    <div className={classes.mobileView}>
                        <SettingsIcon />
                        <Typography variant="caption" display="block" className={classes.text}>Settings</Typography>
                    </div>
                </IconButton>
                <UncontrolledPopover trigger="legacy" placement="bottom" target="PopoverLegacy" className={classes.pop}>
                    <PopoverBody style={{ color: currentTheme.text }}>
                        <div className={classes.root}>
                            <List component="nav" className={classes.root} aria-label="settings" color="inherit">
                                {isAuthorized('User') && (
                                    <Link to='/UserList' >
                                        <ListItem button>
                                            <ListItemText primary="Users" />
                                        </ListItem>
                                    </Link>
                                )}
                                {isAuthorized('User Group') && (
                                    <Link to='/UserGroupList' >
                                        <ListItem button>
                                            <ListItemText primary="User Groups" />
                                        </ListItem>
                                    </Link>
                                )}
                                {isAuthorized('Geography') && (
                                    <Link to='/Geography'>
                                        <ListItem button>
                                            <ListItemText primary="Geography" />
                                        </ListItem>
                                    </Link>
                                )}
                                {isAuthorized('System Variable') && (
                                    <Link to='/SystemVariableList'>
                                        <ListItem button>
                                            <ListItemText primary="System Variables" />
                                        </ListItem>
                                    </Link>
                                )}
                                {isAuthorized('Round List') && (
                                    <Link to='/RoundList'>
                                        <ListItem button>
                                            <ListItemText primary="Round List" />
                                        </ListItem>
                                    </Link>
                                )}
                                {isAuthorized('Unit') && (
                                    <Link to='/UnitList'>
                                        <ListItem button>
                                            <ListItemText primary="Units" />
                                        </ListItem>
                                    </Link>
                                )}
                                <Link to="/ModuleOrder" >
                                    <ListItem button>
                                        <ListItemText primary="Module Order" />
                                    </ListItem>
                                </Link>
                            </List>
                        </div>
                    </PopoverBody>
                </UncontrolledPopover>
            </div>
        );
   
};

export default memo(Settings);
